import React, { useState } from 'react';
import { UKOnlyPostcodeInput } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';
import { checkEmptyFieldValue } from '../../../utils';
import { postCodeFormat, isRequiredAddress } from '../addressUtils/addressUtils';
import { POSTCODE_LIST_ERROR } from '../addressUtils/addressConstants';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const PostCodeComponent = ({
  type,
  saveFormValues,
  onFindAddressClick,
  businessId,
  formValues,
  isAddMunuallyClicked,
  isPostCodeListError,
  postCodeAddressList
}) => {
  const [isPostCodeMissing, updatePostCodeMissing] = useState(false);
  return (
    <Content>
      {(content) => (
        <Field name={`${type}.postcode`} subscription={{ touched: true, error: true }}>
          {({ meta: { touched, error } }) => (
            <GenericFieldWrapper
              name={`${type}.postcode`}
              title={`${getType(type).replace(
                getType(type).charAt(0),
                getType(type).charAt(0).toUpperCase()
              )} address postcode`}
              validationMessage={
                !!error || isPostCodeListError || isPostCodeMissing
                  ? getValidationMessage(content, isPostCodeListError, error, formValues, type)
                  : ''
              }
            >
              <Inline.LeftAligned
                nodes={[
                  <Field
                    name={`${type}.postcode`}
                    type="input"
                    validate={(v) =>
                      isRequiredAddress(
                        v,
                        'postcode',
                        isPostCodeListError,
                        postCodeAddressList,
                        formValues,
                        isAddMunuallyClicked
                      )
                    }
                    value={formValues[`${type}.postcode`]}
                    parse={postCodeFormat}
                  >
                    {({ input }) => (
                      <UKOnlyPostcodeInput
                        id={`${type}.postcode`}
                        onChange={({ value }) => {
                          input.onChange(value);
                          saveFormValues(`${type}.postcode`, value);
                        }}
                        value={formValues[`${type}`] ? formValues[`${type}`].postcode : ''}
                        onBlur={(value) => value && updatePostCodeMissing(false)}
                      />
                    )}
                  </Field>,
                  <>
                    {checkEmptyFieldValue(businessId) ? (
                      ''
                    ) : (
                      <ActionButton.Primary
                        labelText={<Content id="findAddress" />}
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            isRequiredAddress(
                              getPostCodeValues(formValues, type),
                              'postcode',
                              isPostCodeListError
                            ) === 'Required'
                          ) {
                            updatePostCodeMissing(true);
                          } else {
                            updatePostCodeMissing(false);
                            onFindAddressClick(
                              getPostCodeValues(formValues, type).replace(' ', '')
                            );
                          }
                        }}
                      />
                    )}
                  </>
                ]}
              />
            </GenericFieldWrapper>
          )}
        </Field>
      )}
    </Content>
  );
};

const getValidationMessage = (content, isPostCodeListError, error, formValues, type) => {
  if (isPostCodeListError) {
    return content.postCodeSearchError;
  }
  if (
    type === 'register' &&
    formValues &&
    formValues.register &&
    formValues.register.postcode &&
    isValidGlobalBehaviour(formValues.register.postcode, 'postcode')
  ) {
    return content.postCodeListError;
  }
  if (
    type === 'register' &&
    formValues.register &&
    formValues.register.postcode &&
    !isValidGlobalBehaviour(formValues.register.postcode, 'postcode')
  ) {
    return content.postCodeError;
  }
  if (
    type === 'trading' &&
    formValues &&
    formValues.trading &&
    formValues.trading.postcode &&
    isValidGlobalBehaviour(formValues.trading.postcode, 'postcode')
  ) {
    return content.postCodeListError;
  }
  if (
    type === 'trading' &&
    formValues.trading &&
    formValues.trading.postcode &&
    !isValidGlobalBehaviour(formValues.trading.postcode, 'postcode')
  ) {
    return content.postCodeError;
  }
  if (
    type === 'mailing' &&
    formValues &&
    formValues.mailing &&
    formValues.mailing.postcode &&
    isValidGlobalBehaviour(formValues.mailing.postcode, 'postcode')
  ) {
    return content.postCodeListError;
  }
  if (
    type === 'mailing' &&
    formValues.mailing &&
    formValues.mailing.postcode &&
    !isValidGlobalBehaviour(formValues.mailing.postcode, 'postcode')
  ) {
    return content.postCodeError;
  }
  return error === POSTCODE_LIST_ERROR ? content.postCodeSearchError : content.postCodeError;
};

const getPostCodeValues = (formValues, type) =>
  formValues && formValues[`${type}`] ? formValues[`${type}`].postcode : '';

const getType = (type) => (type === 'register' ? 'registered' : type);

PostCodeComponent.propTypes = {
  onManualClick: PropTypes.func,
  addManuallyClicked: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired
};

export default PostCodeComponent;
